import { _GetUrl } from "src/components/UI/Shared/handler";
export const VISITOR_STATUS = {
  ACTIVE: 1,
  VERIFY: 2,
  BLOCKED: 3,
};
export const RESPONSE_STATUS = {
  ACTIVE: 203,
  VERIFY: 303,
  BLOCKED: 403,
};

export const MAPPING_GOTO: { [key: string]: string } = {
  "0": "../../",
  "1": "/Geo/",
  "2": "/Geo/profile",
  "3": "/Geo/identity/login",
  "4": "/Geo/identity/register",
  "5": `/Geo/${_GetUrl(0, 0)}`,
  "6": `/Geo/${_GetUrl(2, 4)}`,
  "7": `/Geo/${_GetUrl(1, 2)}`,
  "8": `/Geo/${_GetUrl(1, 0)}`,
  "9": `/Geo/${_GetUrl(1, 1)}`,
  "10": `/Geo/${_GetUrl(4, 0)}`,
  "11": `/Geo/${_GetUrl(4, 1)}`,
  "12": `/Geo/identity/payment`,
  "13": `/Geo/${_GetUrl(5, 0)}`,
  "14": `/Geo/${_GetUrl(1, 3)}`,
  "15": `/Geo/${_GetUrl(1, 6)}`,
  "16": "/Geo/identity/verification",
  "17": "/Geo/profile",
  "18": `/Geo/${_GetUrl(1, 4)}`,
};

export const BONUS_PER_MONTH = 5;

export const MAPPING_SERVICE_NAME: { [key: string]: string } = {
  extract_shapefile: "Import data from SHP   ",
  extract_kmlfile: "Import data from KML   ",
  generateGeojson_fromKml: "Convert KML to Geojson ",
  generateShp_fromKml: "Convert KML to SHP     ",
  generateFgdb_fromKml: "Convert SHP to Fgdb    ",
  generateGoejson_fromShp: "Convert SHP to Geojson ",
  generateKml_fromShp: "Convert SHP to KML     ",
  generateFgdb_fromShp: "Convert SHP to Fgdb    ",
  generateKml_fromGeojson: "Convert Geojson to KML ",
  generateShp_fromGeojson: "Convert Geojson to SHP ",
  generateFgdb_fromGeojson: "Convert Geojson to Fgdb",
  generateShp_fromGeojsonTxt: "Convert Geojson to SHP ",
  generatefgdb_fromGeojsonTxt: "Convert Geojson to Fgdb",
  solve_serviceArea: "Service area           ",
  solve_routing: "Routing                ",
  solve_geocoding: "Geocoding              ",
  generateFgdb_fromDwg: "Convert CAD to Fgdb    ",
  extract_dwgfile: "Import data from CAD   ",
  generateJson_fromPdf: "Convert Pdf to Json    ",
  generateCad_fromPdf: "Convert Pdf to CAD     ",
  Unknown: "Unknown                ",
};
